import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import * as pedidosApi from '../../api/pedidos';
import { useExigeEmpresaEspecifica } from '../../hooks/useExigeEmpresaEspecifica';
import AvisoSelecioneEmpresa from '../../components/common/AvisoSelecioneEmpresa';
import PageHeader from '../../components/common/PageHeader';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import StatusBadge from '../../components/common/StatusBadge';
import EmptyState from '../../components/common/EmptyState';
import Skeleton from '../../components/common/Skeleton';
import { usePaginacao } from '../../hooks/usePaginacao';
import { formatDate } from '../../utils/date';
import { STATUS_PEDIDO } from '../../utils/storeflowOpcoes';

export default function Pedidos() {
  const { bloqueado, carregandoEmpresas, semEmpresaCadastrada } = useExigeEmpresaEspecifica();
  const [itens, setItens] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState('');
  const [statusFiltro, setStatusFiltro] = useState('');

  useEffect(() => {
    if (bloqueado) {
      setLoading(false);
      return;
    }
    setLoading(true);
    pedidosApi
      .listPedidos({ status: statusFiltro || undefined })
      .then((r) => setItens(r.data))
      .catch(() => setErro('Erro ao carregar pedidos.'))
      .finally(() => setLoading(false));
  }, [bloqueado, statusFiltro]);

  const { paginados, Paginacao } = usePaginacao(itens);

  if (carregandoEmpresas) return <LoadingSpinner />;

  return (
    <div>
      <PageHeader titulo="Saídas (Pedidos)" acaoLabel="Novo pedido" acaoTo="/pedidos/novo" />

      {erro && (
        <div className="sf-login-alert mb-3">
          <i className="bi bi-exclamation-circle" />
          {erro}
        </div>
      )}

      {bloqueado && <AvisoSelecioneEmpresa semEmpresaCadastrada={semEmpresaCadastrada} />}

      {!bloqueado && (
        <div className="sf-table-card">
          <div className="sf-table-toolbar">
            <button type="button" className={`sf-btn ${statusFiltro === '' ? 'sf-btn-primary' : 'sf-btn-ghost'}`} onClick={() => setStatusFiltro('')}>
              Todos
            </button>
            {STATUS_PEDIDO.map((s) => (
              <button
                key={s.value}
                type="button"
                className={`sf-btn ${statusFiltro === s.value ? 'sf-btn-primary' : 'sf-btn-ghost'}`}
                onClick={() => setStatusFiltro(s.value)}
              >
                {s.label}
              </button>
            ))}
          </div>

          {loading ? (
            <div className="p-4">
              <Skeleton linhas={5} />
            </div>
          ) : paginados.length === 0 ? (
            <EmptyState icon="bi-cart-check" titulo="Nenhum pedido encontrado" texto="Ajuste o filtro ou lance uma nova saída." acaoLabel="Novo pedido" acaoTo="/pedidos/novo" acaoIcon="bi-cart-plus" />
          ) : (
            <>
              <div className="table-responsive">
                <table className="sf-table">
                  <thead>
                    <tr>
                      <th>Data</th>
                      <th>Cliente</th>
                      <th>Itens</th>
                      <th>Status</th>
                      <th />
                    </tr>
                  </thead>
                  <tbody>
                    {paginados.map((p) => (
                      <tr key={p.id_pedido}>
                        <td>{formatDate(p.data_pedido)}</td>
                        <td>
                          <span className="d-flex align-items-center gap-2">
                            <span className="sf-cell-icon"><i className="bi bi-cart-check" /></span>
                            <span className="sf-cell-title">{p.cliente ? p.cliente.nome : 'Venda avulsa'}</span>
                          </span>
                        </td>
                        <td>{p.itens.length}</td>
                        <td><StatusBadge status={p.status} /></td>
                        <td className="text-end">
                          <Link to={`/pedidos/${p.id_pedido}`} className="sf-btn sf-btn-ghost">
                            <i className="bi bi-eye" />
                          </Link>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <Paginacao />
            </>
          )}
        </div>
      )}
    </div>
  );
}
